import { memo } from 'react';
import type { ReactNode } from 'react';
import styles from './CollapsibleSideBarFilterTitle.module.css';

const CollapsibleSideBarFilterTitle = ({
    children,
}: {
    children: ReactNode;
}) => {
    return <div className={styles.collapsibleTitle}>{children}</div>;
};

export default memo(CollapsibleSideBarFilterTitle);
